export interface IHospitalAvailability {
  id?: string | null;
  hospitalID: string;
  clinicID: string | null;
  clinicName?:  string | null;
  slots: number;
  availabilityMonth: number;
  availabilityYear: number;
}

export class HospitalAvailability implements IHospitalAvailability {
  id?: string | null;
  hospitalID: string;
  clinicID: string | null;
  clinicName?:  string | null;
  slots: number;
  availabilityMonth: number;
  availabilityYear: number;

  constructor();
  constructor(obj: IHospitalAvailability);
  constructor(obj?: IHospitalAvailability) {
    this.id = obj?.id;
    this.hospitalID = obj?.hospitalID ?? '';
    this.clinicID = obj?.clinicID ?? null;
    this.clinicName = obj?.clinicName ?? null;
    this.slots = obj?.slots ?? 0;
    this.availabilityMonth = obj?.availabilityMonth ?? 0;
    this.availabilityYear = obj?.availabilityYear ?? 0;
  }
}
